module.exports = __webpack_public_path__ + "img/seven1Red.69dd3529.jpg";